function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** Different filter conditions user can select */
export class Type {}
_defineProperty(Type, "eq", 'eq');
_defineProperty(Type, "eqIgnoreCase", 'eqIgnoreCase');
_defineProperty(Type, "notEq", 'notEq');
_defineProperty(Type, "notEqIgnoreCase", 'notEqIgnoreCase');
_defineProperty(Type, "greaterThan", 'greaterThan');
_defineProperty(Type, "greaterThanOrEqualTo", 'greaterThanOrEqualTo');
_defineProperty(Type, "lessThan", 'lessThan');
_defineProperty(Type, "lessThanOrEqualTo", 'lessThanOrEqualTo');
_defineProperty(Type, "in", 'in');
_defineProperty(Type, "inIgnoreCase", 'inIgnoreCase');
_defineProperty(Type, "notIn", 'notIn');
_defineProperty(Type, "notInIgnoreCase", 'notInIgnoreCase');
_defineProperty(Type, "isTrue", 'isTrue');
_defineProperty(Type, "isFalse", 'isFalse');
_defineProperty(Type, "isNull", 'isNull');
_defineProperty(Type, "invoke", 'invoke');
_defineProperty(Type, "contains", 'contains');
_defineProperty(Type, "notContains", 'notContains');
_defineProperty(Type, "containsIgnoreCase", 'containsIgnoreCase');
_defineProperty(Type, "startsWith", 'startsWith');
_defineProperty(Type, "endsWith", 'endsWith');
_defineProperty(Type, "containsAny", 'containsAny');
//# sourceMappingURL=Type.js.map